export const paymentStore = {
    paymentMethods: [],
    card: {
        pubKey: '',
    },
    sepa: {
        pubKey: '',
        clientSecret: '',
        paymentSuccess: false,
    },
};
